import { Chip } from '@mui/material'

// Canonical role → label + color. Reads the User.role enum
// (SUPER_ADMIN | MANUFACTURER | DEALER | USER) that's now the source of truth.
const ROLE_META: { [k: string]: { label: string; color: string } } = {
    SUPER_ADMIN: { label: 'Super Admin', color: '#AA3E98' },
    MANUFACTURER: { label: 'Manufacturer', color: '#8BC441' },
    DEALER: { label: 'Dealer', color: '#508991' },
    USER: { label: 'User', color: '#9AA0A6' },
}

const RoleBadge = ({ role }: { role?: string }) => {
    if (!role) return null
    const m = ROLE_META[role] || { label: role, color: '#9AA0A6' }
    return (
        <Chip
            size="small"
            label={m.label}
            sx={{
                height: 20,
                fontSize: 10.5,
                fontWeight: 700,
                letterSpacing: '0.03em',
                color: m.color,
                bgcolor: 'transparent',
                border: '1px solid',
                borderColor: m.color,
                '& .MuiChip-label': { px: 0.9 },
            }}
        />
    )
}

export default RoleBadge
